import React from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import Moment from "react-moment";

function isEmptyValue(value) {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  return value === "-";
}

function Item({ label, value }) {
  if (isEmptyValue(value)) return null;
  return (
    <Box sx={{ display: "flex", gap: 0.75, mb: 0.75, flexWrap: "wrap" }}>
      <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{label}:</Typography>
      <Typography sx={{ fontSize: 14 }}>{value ?? "-"}</Typography>
    </Box>
  );
}

function Money({ value }) {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
}

export default function TicketDetailsFields({ ticket, hidePaymentSections = false }) {
  const payment = ticket?.payments?.[0];
  const exhibitions = Array.isArray(ticket?.exhibitions) ? ticket.exhibitions : [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Item label="Selected Museum" value={ticket?.museum_name} />
        <Item label="Ticket No." value={ticket?.ticket_no} />
        <Item label="State" value={ticket?.state} />
        <Item label="Payment Status" value={payment?.status} />
        <Item
          label="Ticket Type (API)"
          value={ticket?.ticket_type_name || ticket?.ticket_type_detail?.name || "-"}
        />
        <Item label="Ticket Type (Legacy)" value={ticket?.ticket_type_legacy} />
        <Item
          label="Visitor Type"
          value={ticket?.visitor_type_name || ticket?.ticket_type_detail?.visitor_type?.name || "-"}
        />
        <Item
          label="Nationality"
          value={`${ticket?.nationality || "-"}${ticket?.nationality_other ? ` (${ticket.nationality_other})` : ""}`}
        />
        <Item label="Total Visitor(s)" value={ticket?.no_of_visitor} />
        <Item
          label="Validity"
          value={ticket?.validity ? <Moment format={"lll"}>{ticket.validity}</Moment> : "-"}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Item label="Guide" value={ticket?.guide_detail?.name || ticket?.guide_name} />
        <Item label="Guide Phone" value={ticket?.guide_detail?.phone || ticket?.guide_phone} />
        <Item label="Guide Agent" value={ticket?.guide_detail?.agent_name || ticket?.guide_agent_name} />
        <Box sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 700, mb: 0.5 }}>Exhibitions:</Typography>
          {exhibitions.length === 0 ? (
            <Typography sx={{ fontSize: 14 }}>-</Typography>
          ) : (
            exhibitions.map((x) => (
              <Typography key={x?.id} sx={{ fontSize: 14, ml: 1.5 }}>
                - {x?.name || "-"}
              </Typography>
            ))
          )}
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Divider />
      </Grid>

      {(ticket?.discount_amount > 0) && (
        <Grid item xs={12} md={6}>
          <Item label="Discount" value={ticket?.discount_detail?.name || "-"} />
          <Item label="Discount Amount" value={<Money value={ticket?.discount_amount} />} />
        </Grid>
      )}

      {!hidePaymentSections && (
        <Grid item xs={12} md={6}>
          <Item label="Payment Due" value={<Money value={ticket?.payment_due} />} />
          <Item label="Payment Type" value={ticket?.payment_type} />
        </Grid>
      )}
    </Grid>
  );
}
